import { useEffect } from "react";
import { BASE_URL } from "@/data/site";

export const Seo = ({ title, description, path = "/", jsonLd = [], lang, alternates = [] }) => {
  useEffect(() => {
    document.title = title;
    if (lang) document.documentElement.lang = lang;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `${BASE_URL}${path}`);
    document.querySelectorAll("script[data-seo-jsonld]").forEach((n) => n.remove());
    jsonLd.forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    document.querySelectorAll("link[data-seo-alt]").forEach((n) => n.remove());
    alternates.forEach((a) => {
      const l = document.createElement("link");
      l.setAttribute("rel", "alternate");
      l.setAttribute("hreflang", a.hreflang);
      l.setAttribute("href", `${BASE_URL}${a.path}`);
      l.setAttribute("data-seo-alt", "1");
      document.head.appendChild(l);
    });
  }, [title, description, path, jsonLd, lang, alternates]);
  return null;
};
